module.exports = new __parcel__URL__("elixir_kitemark-60px.d5d618fa.png").toString();